export class Feature {
  constructor(tag, title, text, iconList, mediaResource, mediaAlternative) {
    this.tag = tag
    this.title = title
    this.text = text
    this.iconList = iconList
    this.mediaResource = mediaResource
    this.mediaAlternative = mediaAlternative
  }
}
